export var RateStatus;
(function (RateStatus) {
    RateStatus["Full"] = "full";
    RateStatus["Half"] = "half";
    RateStatus["Void"] = "void";
})(RateStatus || (RateStatus = {}));
